import React, { memo, useCallback } from 'react'

import { Button, Close, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, object, shape, string } from 'prop-types'

const ICON_SIZE = { height: '16px', width: '16px' }
const icon = <Icon notSpaced svgComponent={Close} color="dark" size={ICON_SIZE} />

// Keeps focus in the search input on pointer clicks, so its blur/focus handlers
// (dropdowns, focus rings) do not flicker while the value is cleared.
const preventFocusSteal = event => event.preventDefault()

function SearchClearButton({ label, onClear, inputRef = null }) {
  const handleClick = useCallback(() => {
    onClear()
    inputRef?.current?.focus()
  }, [onClear, inputRef])

  return (
    <Button
      type="ghost"
      size="tiny"
      variant="only-icon"
      actionType="button"
      icon={icon}
      aria-label={label}
      onMouseDown={preventFocusSteal}
      onClick={handleClick}
    />
  )
}

SearchClearButton.propTypes = {
  label: string.isRequired,
  onClear: func.isRequired,
  inputRef: shape({ current: object }),
}

export default memo(SearchClearButton)
